var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentificationCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_20766)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M4.07039 7.2399C5.82113 7.2399 7.24039 5.82065 7.24039 4.0699C7.24039 2.31916 5.82113 0.899902 4.07039 0.899902C2.31965 0.899902 0.900391 2.31916 0.900391 4.0699C0.900391 5.82065 2.31965 7.2399 4.07039 7.2399Z",
    fill: "#91BC68"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M15.8497 19.0202C17.6004 19.0202 19.0197 17.6009 19.0197 15.8502C19.0197 14.0994 17.6004 12.6802 15.8497 12.6802C14.0989 12.6802 12.6797 14.0994 12.6797 15.8502C12.6797 17.6009 14.0989 19.0202 15.8497 19.0202Z",
    fill: "#91BC68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1105 1.81006L1.81055 18.1101",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07039 7.2399C5.82113 7.2399 7.24039 5.82065 7.24039 4.0699C7.24039 2.31916 5.82113 0.899902 4.07039 0.899902C2.31965 0.899902 0.900391 2.31916 0.900391 4.0699C0.900391 5.82065 2.31965 7.2399 4.07039 7.2399Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8497 19.0202C17.6004 19.0202 19.0197 17.6009 19.0197 15.8502C19.0197 14.0994 17.6004 12.6802 15.8497 12.6802C14.0989 12.6802 12.6797 14.0994 12.6797 15.8502C12.6797 17.6009 14.0989 19.0202 15.8497 19.0202Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_20766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.92,
    height: 19.92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationCode);
export default __webpack_public_path__ + "static/media/identificationCode.5978e9aa5d8216f6c17e31ba1043c9d6.svg";
export { ForwardRef as ReactComponent };